import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
var SideMenuWrapper = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isOpen'; },
})(function (_a) {
    var isOpen = _a.isOpen;
    return ({
        display: 'flex',
        flexDirection: 'column',
        width: isOpen ? '18vw' : 72,
        minWidth: isOpen ? 263 : 72,
        height: '100vh',
        backgroundColor: baseColors.bluePreset[10],
        transition: 'width 0.3s ease',
        overflow: 'hidden',
        flexShrink: 0,
        position: 'relative',
        padding: '16px 0px',
        gap: 8,
        '& .menu-logo': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: isOpen ? 'space-between' : 'center',
            padding: isOpen ? '12px 12px 12px 24px' : '12px 24px',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            fontSize: 32,
            '& .menu-logoBrand': {
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                minWidth: 0,
                opacity: isOpen ? 1 : 0,
                width: isOpen ? 'auto' : 0,
                overflow: 'hidden',
                transition: 'opacity 0.2s ease, width 0.2s ease',
                '& .icon-Aux-Logo': {
                    fontSize: 32,
                },
            },
            '& .menu-logoText': {
                color: baseColors.fullWhite,
                display: isOpen ? 'block' : 'none',
                transition: 'opacity 0.2s ease',
                overflow: 'hidden',
                fontSize: 20,
            },
            '& .menu-toggleBtn': {
                border: 0,
                outline: 0,
                padding: 0,
                margin: 0,
                background: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                flexShrink: 0,
            },
            '& span': {
                color: baseColors.fullWhite,
                fontSize: 32,
            },
        },
        '& .menu-nav': {
            flex: 1,
            gap: 8,
            overflowY: 'auto',
            overflowX: 'hidden',
            '&::-webkit-scrollbar': { width: 3 },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255,255,255,0.2)',
                borderRadius: 2,
            },
        },
        '& .menu-item': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: isOpen ? 'space-between' : 'center',
            gap: isOpen ? 8 : 0,
            padding: isOpen ? '12px 12px 12px 24px' : '12px 24px',
            cursor: 'pointer',
            color: baseColors.fullWhite,
            whiteSpace: 'nowrap',
            transition: 'background-color 0.15s, color 0.15s',
            userSelect: 'none',
            '&:hover': {
                backgroundColor: baseColors.successPreset[30],
            },
            '& span': {
                color: baseColors.fullWhite,
                fontSize: 24,
            },
            '& .menu-label': {
                flex: 1,
                opacity: isOpen ? 1 : 0,
                transition: 'opacity 0.15s ease',
                overflow: 'hidden',
            },
            '& .menu-chevron': {
                display: isOpen ? 'flex' : 'none',
                alignItems: 'center',
                '& svg': { color: baseColors.fullWhite },
            },
        },
        '& .menu-item.active': {
            backgroundColor: baseColors.successPreset[30],
            '& .menu-label': {
                fontWeight: 400,
            },
        },
        '& .menu-subItem': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: isOpen ? 'start' : 'center',
            gap: isOpen ? 8 : 0,
            padding: isOpen ? '12px 12px 12px 24px' : '12px 24px',
            cursor: 'pointer',
            color: baseColors.fullWhite,
            whiteSpace: 'nowrap',
            transition: 'background-color 0.15s, color 0.15s',
            userSelect: 'none',
            '&:hover': {
                backgroundColor: baseColors.successPreset[30],
            },
            '& span': {
                color: baseColors.fullWhite,
                fontSize: 24,
            },
            '& .subMenu-iconSlot': {
                display: 'inline-flex',
                justifyContent: 'center',
                width: 24,
                flexShrink: 0,
            },
            '& .subMenu-label': {
                flex: 1,
                opacity: isOpen ? 1 : 0,
                transition: 'opacity 0.15s ease',
                overflow: 'hidden',
            },
        },
        '& .menu-subItem.active': {
            backgroundColor: baseColors.successPreset[30],
            fontWeight: 400,
            '& .subMenu-label': {
                fontWeight: 400,
            },
        },
        '& .menu-footer': {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '12px 18px',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            cursor: 'pointer',
            userSelect: 'none',
            transition: 'background-color 0.15s ease',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
            '& .menu-footerText': {
                color: baseColors.fullWhite,
                opacity: isOpen ? 1 : 0,
                transition: 'opacity 0.15s ease',
                overflow: 'hidden',
            },
        },
        '& .menu-profilePopover .MuiPaper-root': {
            minWidth: 290,
            borderRadius: 6,
            boxShadow: '0px 8px 30px rgba(20, 26, 58, 0.2)',
            marginLeft: 8,
            marginBottom: 8,
            overflow: 'hidden',
        },
        '& .menu-profileCard': {
            backgroundColor: baseColors.fullWhite,
        },
        '& .menu-profileRow': {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '14px 16px',
            '& span, & svg': {
                color: baseColors.bluePreset[10],
                fontSize: 18,
            },
        },
        '& .menu-profileRow--name': {
            '& .menu-profileText': {
                fontWeight: 500,
            },
        },
        '& .menu-profileRow--logout': {
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: baseColors.greyPreset[10],
            },
        },
        '& .menu-profileText': {
            color: baseColors.fullBlack,
            fontSize: 20,
            lineHeight: '28px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    });
});
export default SideMenuWrapper;
